<template>

  <modalo
    :title="member.name"
    type="mini"
    @hideModal="hideModal()">

    <form id="member-form" v-on:submit.prevent="saveMember(member)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-if="member._id"
          type="text"
          class="form-control"
          v-model="member.user_id.name"
          disabled="disabled">
        <input
          v-if="!member._id"
          v-autofocus
          type="text"
          class="form-control"
          v-model="member.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      
      <div class="form-group">
        <label>{{ $t('Email') }}</label>
        <input
          v-if="member._id"
          type="text"
          class="form-control"
          v-model="member.user_id.email"
          disabled="disabled">
        <input
          v-if="!member._id"
          type="text"
          class="form-control"
          v-model="member.email">
        <ValidateMessage :error="validateErrors.email" />
      </div>

      <div class="form-group">
        <label>{{ $t('Role') }}</label>
        <select-role
          v-model="member.role_id">
          </select-role>
        <ValidateMessage :error="validateErrors.role_id" />
      </div>
      
      <div class="form-group">
        <label>{{ $t('Active') }}</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value="1"
            v-model="member.active">
          <label class="form-check-label">
            {{ $t('Active') }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.active" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="member-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteMember(member._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectRole from '@/components/Fields/SelectRole'

export default {
  name: 'MemberForm',
  components: {
    SelectRole
  },
  props: [
    'initMember'
  ],
  data () {
    return {
      loading: false,
      member: this.defaultValues(this.initMember),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveMember
    */
    saveMember (data) {
      if (data._id) this.updateMember(data)
      else this.createMember(data)
    },
    /*
    createMember
    */
    createMember (data) {
      this.loading = true

      this.$store
      .dispatch('createMember', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateMember
    */
    updateMember (data) {
      this.loading = true

      this.$store
      .dispatch('updateMember', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteMember (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteMember', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberUserForm.vue